module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp3_3009.d72e3b79.png";